import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link, Redirect} from 'react-router-dom';

import Toggle from 'react-toggle';
import Select from 'react-select';
import InputMask from 'react-input-mask';

import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import getLocale from '../../i18n/getLocale';

class PaymentRequestScheduleTransportAdd extends Component {
  // constructor
  constructor(props) {
    super(props);

    this.locale = getLocale();

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: 0,
      schedule_grade_id: '',
      staff_id: '',
      daily_currency: 'BRL',
      training_selected: 0,
      daily_value: 0,
      daily_paid: 0,
      ignores_debts: 0,
      observation: '',
      date_start: '',
      date_finish: '',
      bonus: '',
      certification_supplier: '',
      certification_supplier_id: '',
      daily_currency_list: [
        {value: "EUR", label: this.locale.general.euro},
        {value: "USD", label: this.locale.general.dolar},
        {value: "BRL", label: this.locale.general.real},
      ],
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.add = this.add.bind(this);
    this.handleSelectChangeStaff = this.handleSelectChangeStaff.bind(this);
    this.loadStaffData = this.loadStaffData.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleChangeDate (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
    
    var daily_paid = 0;
    var other_date = this.state.date_start;
    if(name === 'date_start') {
      var other_date = this.state.date_finish;
    }

    if(change[name].length === 10 && other_date.length === 10) {
      date1 = change[name].split('/');
      date2 = other_date.split('/');
        
      var date1 = new Date(date1[1] + '/' + date1[0] + '/' + date1[2]);
      var date2 = new Date(date2[1] + '/' + date2[0] + '/' + date2[2]);
        
      // To calculate the time difference of two dates
      var Difference_In_Time = date2.getTime() - date1.getTime();
        
      // To calculate the no. of days between two dates
      daily_paid = Difference_In_Time / (1000 * 3600 * 24);

      daily_paid =  Math.abs(daily_paid) + 1;
    }
    
    this.setState({daily_paid: daily_paid});
    this.handleChangeDailyTotal(this.state.daily_value, daily_paid);
  }

  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  }


  handleChangeDaily (name, event) {
    var change = {};
    change[name] = event.target.value;

    this.setState(change);
    this.handleChangeDailyTotal(event.target.value, this.state.daily_paid);
  }
  handleChangeDailyPaid (name, event) {
    var change = {};
    change[name] = event.target.value;

    this.setState(change);
    this.handleChangeDailyTotal(this.state.daily_value, event.target.value);
  }

  handleChangeDailyTotal (daily_paid, daily_value) {
    var daily_paid = daily_paid.toString().replace(',', '.');
    var daily_value = daily_value.toString().replace(',', '.');
    var total = daily_paid * daily_value;

    this.setState({daily_total: total});
  }

  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }


  handleSelectChangeStaff(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
      this.setState(change, ()=> {
        this.setState({daily_value: ''});
      });
    } else {
      change[name] = event.value;
      this.setState(change, ()=> {
        this.loadStaffData(event);
      });
    }
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }
  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }
  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }


  loadStaffData(event) {
    var header = this.refs.request_api.header('application/json');
    var self = this;
    this.handleAlert('', '', 'open');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/pagamento/valores/funcionario/' + event.value;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          Object.keys(responseJson.data).map(function(k) {
            if (responseJson.data[k].type === 'transport' && responseJson.data[k].currency === self.state.daily_currency) {
              self.setState({daily_value: responseJson.data[k].value_str});
            }
            return true;
          });
        }
        self.handleAlert('', '', 'closed');
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
      });
    });
  }


  loadData () {
    this.handleAlert('', '', 'open');
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/solicitacao/transporte/info';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        if(responseJson.status === 'success') {
          let api = 'api';
          self.setState({api: api, daily_value: responseJson.data.value});
          self.setState({trainings_list: responseJson.data.trainings_list});
          var url_bases = config.get(api) + '/bases/ativas/lista/escala';
          fetch(url_bases, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
            self.refs.request_api.validate(responseJson);
            if (responseJson.status === 'success') {
              self.setState({bases_list: responseJson.data});
            }
          }).then(() => {
            self.setState({overlay: {message: '', type: '', status: 'closed'}});
          }); /* Overlay */
        } else {
          self.setState({overlay: {message: responseJson.message, type: 'error', status: 'open'}});
        }
      }); 
    });
  }

  add(event) {
    event.preventDefault();
    var datasave = {
      training_id: this.state.training_id,
      date_start: this.state.date_start,
      date_finish: this.state.date_finish,
      daily_value: this.state.daily_value,
      daily_paid: this.state.daily_paid,
      daily_total: this.state.daily_total,
      daily_currency: this.state.daily_currency,
      base_id: this.state.base_id,
      observation: this.state.observation,
    };
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
        fetch(config.get(self.state.api) + '/pagamento/treinamento/transporte/solicitacao/cadastrar', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            var url = '/lista/solicitacao/pagamento/transporte/treinamento';
            var storage = {
              alert_message: responseJson.message,
              alert_type: responseJson.status,
            };
            localStorage.setItem("verify_message", JSON.stringify(storage));
            self.setState({redirect_url: url});
          }
            self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'open'}});
        }).catch((error) => {
          console.error(error);
        });
    });
  }

  render() {
    return (
<div>
  
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  <div className="container-liquid">
    <div className="conteudo">
    <h3 className="page-title pull-left">{this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoTreinamentoTransporte.titulo}</h3>
      <Link to="/lista/solicitacao/pagamento/transporte/treinamento" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> {this.locale.general.voltar}</Link>
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.add}>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoTreinamentoTransporte.formulario.Treinamento}:</label>
              <Select
                className="form-field-name"
                name="training_id"
                value={this.state.training_id}
                searchable={true}
                placeholder={this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoTreinamentoTransporte.formulario.placeholder.SelecionarTreinamento}
                onChange={this.handleSelectChange.bind(this, 'training_id')}
                options={this.state.trainings_list}
                required
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoTreinamentoTransporte.formulario.Quantidade}:</label>
              <input value={this.state.daily_paid} name="daily_paid" className="form-control" onChange={this.handleChangeDailyPaid.bind(this, 'daily_paid')} placeholder="" disabled />
            </div>
          </div>
        </div>
        <div className="row">
            <div className="col-md-6">
                <div className="form-group">
                <label>{this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoTreinamentoTransporte.formulario.DataInicial}:</label>
                <InputMask value={this.state.date_start} required maskChar={null} name="date_start" mask="99/99/9999" className="form-control" onChange={this.handleChangeDate.bind(this, 'date_start')} placeholder={this.locale.general.diaMesAno} />
                </div>
            </div>
            <div className="col-md-6">
                <div className="form-group">
                <label>{this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoTreinamentoTransporte.formulario.DataFinal}:</label>
                <InputMask value={this.state.date_finish} required maskChar={null} name="date_finish" mask="99/99/9999" className="form-control" onChange={this.handleChangeDate.bind(this, 'date_finish')} placeholder={this.locale.general.diaMesAno} />
                </div>
            </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoTreinamentoTransporte.formulario.Valor}:</label>
              <input value={this.state.daily_value} name="daily_value" className="form-control" onChange={this.handleChangeDaily.bind(this, 'daily_value')} placeholder="" disabled />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoTreinamentoTransporte.formulario.Moeda}:</label>
              <Select
                className="form-field-name"
                name="daily_currency"
                value={this.state.daily_currency}
                placeholder={this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoTreinamentoTransporte.formulario.placeholder.SelecionarMoeda}
                onChange={this.handleSelectChange.bind(this, 'daily_currency')}
                options={this.state.daily_currency_list}
                required
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoTreinamentoTransporte.formulario.ValorTotal}:</label>
              <input value={this.state.daily_total} disabled="disabled" name="daily_total" className="form-control" onChange={this.handleChangeDaily.bind(this, 'daily_total')} placeholder="" />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
            <label>{this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoTreinamentoTransporte.formulario.Base}:</label>
              <Select
                className="form-field-name"
                name="base_id"
                value={this.state.base_id}
                placeholder={this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoTreinamentoTransporte.formulario.placeholder.SelecionarBase}
                onChange={this.handleSelectChange.bind(this, 'base_id')}
                options={this.state.bases_list}
                required
              />
            </div>
          </div>
        </div>        
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoTreinamentoTransporte.formulario.Observacao}:</label>
              <input value={this.state.observation} name="observation" className="form-control" onChange={this.handleChange.bind(this, 'observation')} placeholder={this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoTreinamentoTransporte.formulario.placeholder.Observacao} />
            </div>
          </div>
        </div>        
        <div className="row">
          <div className="col-md-12">
            <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoTreinamentoTransporte.formulario.botaoSalvarPagamento}</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
    );
  }
}

export default PaymentRequestScheduleTransportAdd;



// WEBPACK FOOTER //
// ./src/Components/Payments/PaymentRequestTrainingTransportAdd.js